import { createVideoPlayer } from './video-player.js';

const PREVIEW_HEADER_CLASS = 'acf-th--video-preview';

function debounce(fn, delay) {
   let t;
   return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
   };
}

function buildPreviewCell() {
   const td = document.createElement('td');
   td.className = 'acf-field acf-field--video-preview';
   td.style.cssText = 'width:280px; min-width:280px; padding:8px 12px; vertical-align:top;';

   const wrap = document.createElement('div');
   wrap.className = 'video-preview-wrap';
   wrap.style.cssText = 'position:relative; width:256px; height:144px; background:#1a1a1a; border-radius:6px; overflow:hidden;';

   td.appendChild(wrap);
   return { td, wrap };
}

function updateRowPreview(row) {
   const wrap = row.querySelector('.video-preview-wrap');
   if (!wrap) return;

   const platformInput = row.querySelector('.acf-field[data-name="platform"] input[type="radio"]:checked');
   const idInput       = row.querySelector('.acf-field[data-name="video_id"] input[type="text"]');

   const platform = platformInput?.value ?? '';
   const id       = idInput?.value?.trim() ?? '';

   if (platform && id) {
      createVideoPlayer(wrap, platform, id);
   } else {
      wrap.innerHTML = '';
   }
}

function bindRowEvents(row) {
   const debouncedUpdate = debounce(() => updateRowPreview(row), 600);

   row.querySelectorAll('.acf-field[data-name="platform"] input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => updateRowPreview(row));
   });

   const idInput = row.querySelector('.acf-field[data-name="video_id"] input[type="text"]');
   if (idInput) idInput.addEventListener('input', debouncedUpdate);
}

function addPreviewToRow(row) {
   if (row.querySelector('.acf-field--video-preview')) return;
   if (row.classList.contains('acf-clone')) return; // skip template row

   const { td, wrap } = buildPreviewCell();

   // Insert before the remove handle cell (at end of row)
   const removeHandle = row.querySelector('.acf-row-handle.remove');
   if (removeHandle) {
      row.insertBefore(td, removeHandle);
   } else {
      row.appendChild(td);
   }

   bindRowEvents(row);
   updateRowPreview(row);
}

function addPreviewHeader(table) {
   const thead = table.querySelector('thead tr');
   if (!thead || thead.querySelector('.' + PREVIEW_HEADER_CLASS)) return;

   const th = document.createElement('th');
   th.className = 'acf-th ' + PREVIEW_HEADER_CLASS;
   th.textContent = 'Preview';
   th.style.cssText = 'width:280px; min-width:280px;';

   // Both handle TH elements only have 'acf-row-handle' — target the last one (remove)
   const headerHandles = thead.querySelectorAll('.acf-row-handle');
   const lastHeaderHandle = headerHandles[headerHandles.length - 1];
   if (lastHeaderHandle) {
      thead.insertBefore(th, lastHeaderHandle);
   } else {
      thead.appendChild(th);
   }
}

function setup() {
   const repeater = document.querySelector('.acf-field[data-name="client_videos"] .acf-repeater');
   if (!repeater) return;

   const table = repeater.querySelector('table');
   if (!table) return;

   addPreviewHeader(table);
   table.querySelectorAll('tbody .acf-row').forEach(addPreviewToRow);

   // Watch for rows added dynamically (Add Row button)
   new MutationObserver((mutations) => {
      mutations.forEach((m) => {
         m.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.classList.contains('acf-row')) {
               addPreviewToRow(node);
            }
         });
      });
   }).observe(table.querySelector('tbody'), { childList: true });
}

export function initVideoPreviewAdmin() {
   if (!document.body.classList.contains('wp-admin')) return;

   // Use ACF's ready hook so the repeater is fully rendered before we touch it
   if (typeof acf !== 'undefined') {
      acf.addAction('ready', setup);
   } else {
      document.addEventListener('DOMContentLoaded', setup);
   }
}
